import { Injector } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { CheckinHttpClient } from 'src/app/shared/services/http/http-client.service';
import { Subject } from 'rxjs';
import { EnvService } from 'src/app/shared/common/services/env.service';
import { sanitizeHash } from 'src/app/shared/utils/sanitize';
import { ErrorHandler } from 'src/app/shared/handlers/error.handler';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { AnalyticsService } from 'src/app/shared/services/analytics/analytics.service';
import { EModules } from 'src/app/app.enum';
import * as i0 from "@angular/core";
var BookingGuard = /** @class */ (function () {
    function BookingGuard() {
        var injector = InjectorService.get();
        this.config = injector.get(ConfigService);
        this.env = injector.get(EnvService);
        this.http = injector.get(CheckinHttpClient);
        this.analyticsService = injector.get(AnalyticsService),
            this.error = new ErrorHandler();
    }
    BookingGuard.prototype.canActivate = function (route) {
        var _this = this;
        var hash = sanitizeHash(route.paramMap.get('hash'));
        var project = this.config[this.config.project];
        Object.assign(project, {
            hash: hash,
            fallbackUrl: project.baseCheckinUrl + "/" + hash,
            routeFallback: "/" + this.config.project + "/" + hash
        });
        var url = this.env.endpoint + "/v2/config/" + this.config.project + "/" + project.hash;
        var result = new Subject();
        this.http.get(url).subscribe(function (checkinConfig) {
            if (!checkinConfig) {
                _this.error.handler(new Error("Checkin config is required: " + JSON.stringify(checkinConfig, null, 2)));
                result.next(false);
                return;
            }
            _this.config.update(checkinConfig, function () { return result.next(true); });
            if (_this.config.project === EModules.CHECKIN) {
                _this.analyticsService.openCheckin(_this.config.project);
            }
        }, function (err) { return _this.error.handler(err).subscribe(function (r) { return result.next(r); }); });
        return result.asObservable();
    };
    BookingGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BookingGuard_Factory() { return new BookingGuard(); }, token: BookingGuard, providedIn: "root" });
    return BookingGuard;
}());
export { BookingGuard };
